import React from "react";
import { Button as AntButton } from "antd";
import styled from "styled-components";
import { device } from "../globalAssets/breakpoints";

interface ButtonInterface {
  width?: string;
  htmlType?: string;
  disabled?: boolean;
  text: string;
  onClick?: () => void;
  style?: React.CSSProperties;
  loading?: boolean;
  colorProp?: boolean;
}

export const LoggerButton: React.FC<ButtonInterface> = ({
  colorProp,
  width,
  htmlType,
  disabled,
  text,
  onClick,
  style,
  loading,
}) => {
  return (
    <Container>
      <StyledButton
        colorProp={colorProp}
        style={{ ...style }}
        disabled={disabled}
        width={width}
        size="large"
        onClick={onClick}
        htmlType={htmlType}
        loading={loading}
      >
        {text}
      </StyledButton>
    </Container>
  );
};
interface ButtonProp {
  width: string;
  colorProp: boolean;
}
const StyledButton: any = styled(AntButton)<ButtonProp>`
  border: ${(props) => props.theme.primaryColor};
  cursor: pointer;
  background: ${(props) =>
    props.colorProp ? props.theme.foreground : props.theme.primaryColor};
  color: ${(props) =>
    props.colorProp ? props.theme.color : props.theme.white};
  font-weight: 500;
  box-shadow: ${(props) => (props.colorProp ? "none" : props.theme.shadow)};
  border-radius: 5px;
  border: ${(props) =>
    props.colorProp ? `1px solid ${props.theme.subtleBlack}` : `none`};
  width: ${(props) => props.width};
  transition: all 0.5s ease;

  :active,
  :focus,
  :hover {
    box-shadow: none;
    transition: all 0.5s ease;
    background: ${(props) =>
      props.colorProp ? props.theme.foreground : props.theme.primaryColor};
    color: ${(props) =>
      props.colorProp ? props.theme.color : props.theme.white};
  }
`;

const Container = styled.div`
  text-align: center;
  ${"" /* margin-top: -20px; */}
  @media ${device.laptop} {
    width: 100%;
    margin: 0;
    height: 2.5vw;
    text-align: center;
  }
`;
